// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Rx-L","options":"AnswerScale_options__1oWBk","selected":"AnswerScale_selected__20_Ke"};